/* ---- BUNDLE GRID: 96 FRAMES, NOT 48 ----
   The builder renders one page of the range at a time. That page is 48,
   which on the 25 KD range means 48 of 728 — so all but the first page
   depended on a shopper pressing "Show more", and best-selling order then
   kept the same frames on top of the pile indefinitely.

   WHY 96 IS SAFE, AND WHY IT IS NOT UNLIMITED. Picking a frame rebuilds the
   whole grid, so the page size is a responsiveness budget, not a display
   preference. Measured on the live page: 48 cards rebuild in 17ms, 96 in
   31ms. An earlier version rendered the entire range and the rebuild was
   slow enough that the next tap did nothing — that is the failure this
   number exists to avoid, so it is doubled, not removed.

   WHY IT EXPANDS RATHER THAN SETTING THE NUMBER. bundleShown lives inside
   the closure in sf-claude.js and cannot be reached from outside. But
   showMoreBundles IS published on SF, and one call moves 48 to 96. So this
   presses it once, on the shopper's behalf.

   ---- WHAT WAS WRONG IN v7 ----
   The previous version waited for `load`, attached a MutationObserver to
   the grid, and called step() once. Both halves of that were conditional on
   timing the page does not guarantee:

     - step() ran only if the Show more button was already visible. That
       button is shown only once the pool has been fetched AND rendered, and
       the grid starts empty, so `load` — which waits for the document's own
       images, of which the grid has none — routinely fired first.
     - the observer was then the only remaining chance, and it fires only if
       the grid mutates AFTER `load`. On a bare /pages/bundles it does not:
       the pool render has already happened by then.

   Arriving with ?bundle= worked by accident. sf-bundlelink calls SF.setTier
   on DOMContentLoaded, which starts a second pool fetch; that second fetch
   resolved after `load`, mutated the grid, and woke the observer. The grid
   expanded because of a duplicated request.

   ---- WHAT IT DOES NOW ----
   No observer, no button-visibility test, no race. The count is expanded
   exactly once per tier, and setTier — the only thing that resets it back
   to 48 — is wrapped so the expansion is re-applied every time the shopper
   switches offer.

   Expanding before the pool has arrived is harmless: showMoreBundles only
   raises a number and re-renders, and the grid is empty at that point. When
   the frames land they are sliced to 96 rather than 48.

   IT ARMS AFTER EVERY OTHER SCRIPT. This runs on DOMContentLoaded inside a
   setTimeout(0), which puts it behind sf-claude's boot, sf-bundlefilters'
   bar, sf-bundleorder's hand-off and sf-bundlelink's own setTier call — so
   it wraps the outermost setTier and expands the tier the shopper actually
   landed on.
*/
(function(){
"use strict";
var PAGES=1;           /* extra pages to open: 1 => 48 + 48 = 96 */
var armed=false, tries=0;

function expand(){
  if(!window.SF || typeof window.SF.showMoreBundles!=='function') return false;
  for(var i=0;i<PAGES;i++) window.SF.showMoreBundles();
  return true;
}

function arm(){
  if(armed) return;
  if(!window.SF || typeof window.SF.showMoreBundles!=='function'){
    /* sf-claude.js publishes SF before boot, so this should never be hit.
       Bounded anyway: a missing SF must not spin. */
    if(++tries<40) setTimeout(arm,50);
    return;
  }
  armed=true;

  /* setTier puts the count back to 48. Without this, switching from
     2-for-40 to 3-for-55 would quietly drop to half a page — the kind of
     fault that looks like it works. */
  if(typeof window.SF.setTier==='function'){
    var orig=window.SF.setTier;
    window.SF.setTier=function(){
      orig.apply(this, arguments);
      expand();
    };
  }
  expand();
}

function start(){
  if(!document.getElementById('bGrid')) return;
  setTimeout(arm,0);
}

if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start);
else start();
})();